/* eslint-disable camelcase */
import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { Payload, SearchResult } from '../types';
import { EVENTS } from '../constants';
import { mapBase } from './mapBase';

export const mapSearch = (triggerName: ANALYTICS_TRIGGERS, payload: Payload): SearchResult => ({
    ...mapBase(payload),
    action: EVENTS.SEARCH,
    event_trigger: triggerName,
    source_page: triggerName, // search is the source, so we map it from the trigger
    search_term: payload.payload?.searchQuery || '',
    search_success: payload.payload?.hasSearchResults || false,
    thing_id: payload.payload?.asset?.id || '',
});
